/*
 * Copyright (c) 2023 Your Company Name
 * All rights reserved.
 */
/*
 *   Copyright (c) 2023
 *   All rights reserved.
 */

const baseURL = "https://www.sentracking.com:8443";
//const baseURL = "http://localhost:8080";

const versionApi = "api/v1";
//auth

export const authentificationURL = baseURL + "/authenticate";

export const changePasswordURL = baseURL + "/updatePassword";

//sim

export const listeCarteSimUnusedURL =
  baseURL + "/" + versionApi + "/sim/getallunusedsimcarte";

export const listeCarteSimURL =
  baseURL + "/" + versionApi + "/sim/getallsimcarte";

export const itemCarteSimURL = baseURL + "/" + versionApi + "/sim/getsimcarte";

export const addCarteSimURL = baseURL + "/" + versionApi + "/sim/addsimcarte";

export const updateCarteSimURL =
  baseURL + "/" + versionApi + "/sim/updatesimcarte";

export const delCarteSimURL =
  baseURL + "/" + versionApi + "/sim/disablesimcarte";

// client

export const listeClientURL = baseURL + "/" + versionApi + "/clients";

export const itemClientURL = baseURL + "/" + versionApi + "/client";

export const addClientURL = baseURL + "/" + versionApi + "/clients";

export const updateClientURL = baseURL + "/" + versionApi + "/client";

export const delClientURL = baseURL + "/" + versionApi + "/client/delete/";

//Device

export const listeDeviceURL =
  baseURL + "/" + versionApi + "/devices/getalldevice";

export const itemDeviceURL = baseURL + "/" + versionApi + "/devices/getdevice";

export const addDeviceURL = baseURL + "/" + versionApi + "/devices/adddevice";

export const updateDeviceURL =
  baseURL + "/" + versionApi + "/devices/updatedevice";

export const delDeviceURL =
  baseURL + "/" + versionApi + "/devices/disabledevice/";

export const listeDeviceInutiliserURL =
  baseURL + "/" + versionApi + "/devices/getdeviceinutiliser";

//Vehicule

export const listeVehiculeURL =
  baseURL + "/" + versionApi + "/vehicule/getallvehiculeforcustomer";

export const listeVehiculeByUserURL =
  baseURL + "/" + versionApi + "/vehicule/getallvehicule";

export const itemVehiculeURL =
  baseURL + "/" + versionApi + "/vehicule/getvehicule";

export const addVehiculeURL =
  baseURL + "/" + versionApi + "/vehicule/addvehicule";

export const updateVehiculeURL =
  baseURL + "/" + versionApi + "/vehicule/updatevehicule";

export const delVehiculeURL =
  baseURL + "/" + versionApi + "/vehicule/disablevehicule/";

export const enableVehiculeURL =
  baseURL + "/" + versionApi + "/vehicule/enablevehicule/";

export const updatePictureVehiculeURL =
  baseURL + "/" + versionApi + "/vehicule/uploadPhotoVehicule/";

export const listePostionVehiculeURL =
  baseURL + "/" + versionApi + "/vehicule/getpositionclientforuser";

//User

export const listeUserURL =
  baseURL + "/" + versionApi + "/user/getallusersforcustomer";

export const itemUserURL = baseURL + "/" + versionApi + "/user/getuser";

export const addUserURL = baseURL + "/" + versionApi + "/user/adduser";

export const updateUserURL = baseURL + "/" + versionApi + "/user/updateuser";

export const delUserURL = baseURL + "/" + versionApi + "/user/disableuser/";

export const enableUserURL = baseURL + "/" + versionApi + "/user/enableuser/";

// Role

export const listeRoleURL = baseURL + "/" + versionApi + "/role/getallrole";

//relancePaiement

export const listLastRappelPaiementURL =
  baseURL + "/" + versionApi + "/paiement/listAllRappelPaiementForUser";

export const enregistrerRappelPaiementURL =
  baseURL + "/" + versionApi + "/paiement/enregistrerRappelPaiement";

// paiement

export const listePaiementAllCustumerURL =
  baseURL + "/" + versionApi + "/paiement/paiementsAllClient";

export const listPaiementOFOneCustomerURL =
  baseURL + "/" + versionApi + "/paiement/paiementsForOneClient";

export const addPaiementURL =
  baseURL + "/" + versionApi + "/paiement/validerPaiement";

export const delPaiementURL =
  baseURL + "/" + versionApi + "/paiement/deletePaiement";

export const itemPaiementURL =
  baseURL + "/" + versionApi + "/paiement/deletePaiement";

export const updatePaiementURL =
  baseURL + "/" + versionApi + "/paiement/deletePaiement";

export const verifPurchaseURL =
  baseURL + "/" + versionApi + "/paiement/verifierPaiements";

export const listCategoryPaiementURL =
  baseURL + "/" + versionApi + "/paiement/allCategoryPaiement";

// command

export const listeTypeCommandURL =
  baseURL + "/" + versionApi + "/command-terminal/list-commande-terminal";

export const lancerCommandURL =
  baseURL + "/" + versionApi + "/command-terminal/lancer-commande-vehicule";

//trajet

export const listePositionURL =
  baseURL + "/" + versionApi + "/devices/positions-vehicule";

export const listeTrajetURL = baseURL + "/" + versionApi + "/trajets-vehicule";

//aa

// parametre

export const listParamForUserPerVehiculeURL =
  baseURL + "/" + versionApi + "/user/parametres";

export const updateParamForUserPerVehiculeURL =
  baseURL + "/" + versionApi + "/user/mettreAjourListeParametresVehicule";

export const updatePermissionForUserPerVehiculeURL =
  baseURL + "/" + versionApi + "/vehicule/updateVehiculePermission";

// Notification

export const listeNotificationURL =
  baseURL + "/" + versionApi + "/notification/listNotification";

// Dashboard

export const dashboardURL = baseURL + "/" + versionApi + "/dashbord";
